<template>
  <div class="text-base md:text-lg">
    <!-- HERO -->
    <HeroEvent :page="page" />

    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <!-- LEAD -->
    <div v-if="page.lead" class="pt-10 sm:pt-12 md:pt-14 lg:pt-16 xl:pt-20">
      <LeadText :lead="page.lead" />
    </div>

    <!-- COMPONENT LOADER -->
    <ComponentsLoader v-if="page.components" :components="page.components" />

    <!-- CONTACT TEASER -->
    <ContentContactTeaser v-if="page.person" :data="page" />
  </div>
</template>

<script setup>
import { useTitle } from '@vueuse/core'
defineProps({
  page: { type: Object, required: true },
})

const title = useTitle()
let breadcrumbs = [
  {
    url: null,
    title: 'Über den Landenhof',
    blueprint: 'section',
  },
  {
    url: '/ueber-den-landenhof/events',
    title: 'Events',
    blueprint: null,
  },
  {
    url: null,
    title: title.value,
    blueprint: 'section',
  },
]
</script>
